(() => {
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined && content !== null) node.textContent = String(content);
    return node;
  };
  const reviewStars = score => {
    const line = element('div','sf-review-meta');
    const stars = element('span','sf-review-stars');
    if (Number.isFinite(Number(score)) && score !== null) {
      const value = Math.min(5,Math.max(0,Math.round(Number(score))));
      stars.setAttribute('aria-label',Number(score) + ' von 5 Sternen');
      for (let n = 1; n <= 5; n++) {
        const star = element('span', n > value ? 'sf-review-star-empty' : '', '★');
        star.setAttribute('aria-hidden','true');
        stars.append(star);
      }
    }
    line.append(stars);
    return line;
  };
  const renderReview = (data, page) => {
    const layout = element('article','sf-editorial-review');
    const profile = element('div','sf-review-profile');
    profile.append(window.sfReviewUI.avatar(data.name,data.identity,data.avatar),element('span','sf-review-person-name',data.name));
    layout.append(profile,reviewStars(data.score),element('h3','sf-review-title sf-review-heading-title',data.title || 'Rezension zum Buch'));
    const context = element('div','sf-review-context');
    if (data.purchaseDate) context.append(element('p','sf-review-purchase-date','Gekauft am ' + data.purchaseDate));
    if (data.date) context.append(element('p','sf-review-date','Bewertet am ' + data.date));
    context.append(element('p','sf-review-product-line',(data.verified ? 'Gekauftes E-Book' : 'Bewertetes E-Book') + ' · Warum sich nichts verändert'));
    if (data.verified) context.append(element('span','sf-review-verified','Verifizierter Kauf'));
    layout.append(context);
    const excerpt = element('div','sf-review-excerpt');
    excerpt.append(element('blockquote','',data.text));
    if (data.text.length > 115) {
      excerpt.classList.add('sf-review-can-expand');
      const button = element('button','sf-review-read-more sf-review-inline-more','');
      button.type = 'button';
      button.hidden = true;
      button.setAttribute('aria-expanded','false');
      const caption = element('span','sf-review-more-label',page.dataset.moreLabel || 'Mehr anzeigen');
      const chevron = element('span','sf-review-chevron');
      chevron.setAttribute('aria-hidden','true');
      button.append(caption,chevron);
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const open = excerpt.classList.toggle('sf-review-expanded');
        button.setAttribute('aria-expanded',String(open));
        caption.textContent = open ? page.dataset.lessLabel || 'Weniger anzeigen' : page.dataset.moreLabel || 'Mehr anzeigen';
      });
      excerpt.append(button);
    }
    layout.append(excerpt);
    return layout;
  };
  const updateExcerptOverflow = excerpt => {
    const quote = excerpt.querySelector('blockquote');
    const button = excerpt.querySelector('.sf-review-inline-more');
    if (!quote || !button || !quote.getClientRects().length) return;
    const wasExpanded = excerpt.classList.contains('sf-review-expanded');
    if (wasExpanded) excerpt.classList.remove('sf-review-expanded');
    const collapsedHeight = quote.getBoundingClientRect().height;
    const oldStyle = quote.getAttribute('style');
    quote.style.setProperty('display','block','important');
    quote.style.setProperty('height','auto','important');
    quote.style.setProperty('max-height','none','important');
    quote.style.setProperty('overflow','visible','important');
    quote.style.setProperty('-webkit-line-clamp','unset','important');
    quote.style.setProperty('-webkit-mask-image','none','important');
    quote.style.setProperty('mask-image','none','important');
    quote.style.setProperty('transition','none','important');
    const fullHeight = quote.getBoundingClientRect().height;
    if (oldStyle === null) quote.removeAttribute('style');
    else quote.setAttribute('style',oldStyle);
    const truncated = fullHeight > collapsedHeight + 3;
    if (wasExpanded && truncated) excerpt.classList.add('sf-review-expanded');
    excerpt.classList.toggle('sf-review-actually-truncated',truncated);
    button.hidden = !truncated;
    button.setAttribute('aria-expanded',String(wasExpanded && truncated));
  };
  const mount = () => document.querySelectorAll('[data-sf-review-page]').forEach(page => {
    if (page.dataset.sfReady) return;
    page.dataset.sfReady = 'true';
    const refreshOverflow = () => page.querySelectorAll('.sf-editorial-review .sf-review-excerpt.sf-review-can-expand').forEach(updateExcerptOverflow);
    window.addEventListener('resize',refreshOverflow,{passive:true});
    window.addEventListener('load',refreshOverflow,{once:true});
    document.fonts?.ready?.then(refreshOverflow);
    const source = page.querySelector('.sf-judge-reviews');
    const end = page.querySelector('[data-sf-reviews-end]');
    if (!source || !end) return;
    // Align the skeleton precisely above the space reserved for real review cards.
    // The review list stays in document flow, preventing the previous unfolding jump.
    const positionSkeleton = () => {
      const box = source.getBoundingClientRect();
      const origin = page.getBoundingClientRect();
      page.style.setProperty('--sf-review-skeleton-top',Math.round(box.top - origin.top) + 'px');
      page.style.setProperty('--sf-review-skeleton-left',Math.round(box.left - origin.left) + 'px');
      page.style.setProperty('--sf-review-skeleton-width',Math.round(box.width) + 'px');
    };
    positionSkeleton();
    window.addEventListener('resize',positionSkeleton,{passive:true});
    document.fonts?.ready?.then(positionSkeleton);
    let scheduled = 0;
    let requested = new URL(window.location.href).searchParams.get('rezension');
    let lastLoadedCount = -1;
    let ready = false;
    const signatures = new WeakMap();
    const skeletonStarted = performance.now();
    let skeletonCompletionTimer = 0;
    const finishLoading = () => {
      if (ready) return;
      const remaining = 650 - (performance.now() - skeletonStarted);
      if (remaining > 12) {
        if (!skeletonCompletionTimer) skeletonCompletionTimer = setTimeout(() => {
          skeletonCompletionTimer = 0;
          finishLoading();
        },remaining);
        return;
      }
      ready = true;
      page.dataset.sfReviewsReady = 'true';
      page.setAttribute('aria-busy','false');
    };
    const fallback = setTimeout(finishLoading,7000);
    const sync = () => {
      scheduled = 0;
      const rows = Array.from(source.querySelectorAll('.jm-review-item, .jdgm-review-card, .jdgm-rev'));
      const loaded = rows.length || source.querySelector('.jm-no-reviews-state, .jdgm-rev-widg__no-rev, .jdgm-no-reviews');
      const header = source.querySelector('.jm-average-rating-display')?.textContent || '';
      const totalMatch = header.match(/([\d.,]+)\s+(?:Bewertungen?|Rezensionen?)\b/i);
      const total = Number(totalMatch?.[1].replace(/[.,]/g,'') || page.dataset.reviewCount || 0);
      end.hidden = !(total > 0 && rows.length >= total);
      rows.forEach(row => {
        const data = window.sfReviewUI?.read(row);
        if (!data) return;
        const key = window.sfReviewUI.key(data.name,data.text);
        row.dataset.sfReviewKey = key;
        window.sfReviewUI.remember(data);
        const signature = JSON.stringify([data.name,data.title,data.text,data.score,data.date,data.purchaseDate,data.verified]);
        if (signatures.get(row) !== signature) {
          const old = Array.from(row.children).find(node => node.classList.contains('sf-editorial-review'));
          if (old) old.remove();
          row.prepend(renderReview(data,page));
          row.classList.add('sf-editorial-ready');
          signatures.set(row,signature);
        }
        if (requested && (requested === key || requested === row.getAttribute('review-uuid') || requested === data.uuid)) {
          const toggle = row.querySelector('.sf-editorial-review .sf-review-inline-more');
          if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
          requested = null;
        }
      });
      requestAnimationFrame(() => {
        rows.forEach(row => {
          const excerpt = row.querySelector('.sf-editorial-review .sf-review-excerpt.sf-review-can-expand');
          if (excerpt) updateExcerptOverflow(excerpt);
        });
      });
      if (loaded && (rows.length === 0 || rows.every(row => row.classList.contains('sf-editorial-ready')))) {
        clearTimeout(fallback);
        requestAnimationFrame(() => requestAnimationFrame(finishLoading));
      }
      if (requested && rows.length < total && rows.length !== lastLoadedCount) {
        const more = source.querySelector('.jm-pagination-controls button:not([disabled])');
        if (more) {
          lastLoadedCount = rows.length;
          more.click();
        }
      }
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) scheduled = requestAnimationFrame(sync);
    });
    observer.observe(source,{childList:true,subtree:true,characterData:true});
    document.addEventListener('shopify:section:unload', () => {
      if (!page.isConnected) {
        observer.disconnect();
        clearTimeout(fallback);
        clearTimeout(skeletonCompletionTimer);
        cancelAnimationFrame(scheduled);
      }
    },{once:true});
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount);
  else mount();
  document.addEventListener('shopify:section:load',mount);
})();